export default function MainDetails({ name, address, phone, email }) {
  return (
    <>
      <section className="flex flex-col items-end justify-end">
        <h2 className="font-bold text-3xl uppercase mb-1">{name}</h2>
        <p>{email}</p>
        <p>{phone}</p>
        <p>{address}</p>
      </section>
    </>
  )
}
